export default "__VITE_ASSET__DwEbyv9O__"